<template>
    <div class="container-view">

        <!-- Container boas-vindas -->
        <welcome-dash-container :userName="account.owner.name" />

        <!-- Container principal de dados -->
        <div v-if='account.plan.services === full'>

            <!-- Container visitas -->
            <visit-container :impressionsWeek="impressionsWeek" />

            <!-- Container de filtro -->
            <filter-container @showAlert='showAlert'  />

            <!-- Container infos -->
            <infos-container 
                :impressions="dashData.impressions ? dashData.impressions.impressionsTotal : 0" 
                :usersTotal="dashData.impressions ? dashData.impressions.usersByDate : 0" 
                :cities="dashData.impressions ? dashData.impressions.citiesSearched : 0"

            /> 

            <!-- Container de clicks -->
            <clicks-container 
                :pieData='dashData.pieClicks ? dashData.pieClicks : []' 
                :loading="loading" 
                :faceClicks="dashData.clicks ? dashData.clicks.facebook : 0"        
                :websiteClicks="dashData.clicks ? dashData.clicks.website : 0" 
                :phoneClicks="dashData.clicks ? dashData.clicks.phone : 0" 
                :whatsClicks="dashData.clicks ? dashData.clicks.whatsapp : 0" 
                :buynowClicks="dashData.clicks ? dashData.clicks.buynow : 0" 
                :showedData="dashData.clicks ? dashData.clicks.total : 0" 
                :impressions="dashData.impressions ? dashData.impressions.impressionsTotal: 0" 
            />

            <!-- Container Gráfico de impressão diária -->
            <impression-by-day-chart-container :chartData="dashData.clicksChart" />

            <!-- Mapa -->
            <map-container v-if="dashData.impressions" :heatData="dashData.impressions ? dashData.impressions.heatMap : []" :mapData="dashData.impressions.impressionFormat" :tableData="dashData.impressions ? dashData.impressions.tableDataCitiesFormat : []" />

            <!-- Tabela de impressões -->
            <impression-by-location-table-container :dashData="dashData.impressions ? dashData.impressions.impressionFormat : []" /> 

            <!-- Botão de exportação -->
            <div class="d-flex" :class="isMobile ? 'justify-center' : ' justify-end mr-5'">
                <buttons-to-csv-xls :data='dashData.impressions ? dashData.impressions.impressionFormat : []' />
            </div>

        </div>

        <!-- Container footer -->
        <footer-container />

        <!-- Container infos footer -->
        <footer-infos /> 

        <!-- Modal Planos -->
        <modal-to-payment v-if="!dialogWizard" :activate="checkAccountIncomplete" />

        <!-- Modal Wizard -->
        <v-dialog v-model="dialogWizard" persistent max-width='500px'>

            <v-app-bar color="primary" dense dark>

                <v-toolbar-title>{{$t('assistant')}}</v-toolbar-title>

                <v-spacer></v-spacer>

                <v-btn icon text @click="dialogWizard = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>

            </v-app-bar>

            <wizard-stepper @providerRegister='checkProvider' @uploadDone='afterWizard' @uploadFail='afterWizardFail' />

        </v-dialog>

    </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { ROUTE_HOME_ACCOUNT } from '../../router/routes'
import { GET_DASHDATA, GET_PROFILE, SET_DASHDATA } from '../../store/mutations'
import { dashOverviewFilters } from '../../filters/dashOverviewFilters'
import ModalToPayment from '../components/dashOverview/ModalToPayment.vue'
import WelcomeDashContainer from '../components/dashOverview/WelcomeDashContainer.vue'
import VisitContainer from '../components/dashOverview/VisitContainer.vue'
import InfosContainer from '../components/dashOverview/InfosContainer.vue'
import FilterContainer from '../components/dashOverview/FilterContainer.vue'
import ClicksContainer from '../components/dashOverview/ClicksContainer.vue'
import FooterContainer from '../components/dashOverview/FooterContainer.vue'
import ImpressionByLocationTableContainer from '../components/dashOverview/ImpressionByLocationTableContainer.vue'
import ImpressionByDayChartContainer from '../components/dashOverview/ImpressionByDayChartContainer.vue'
import MapContainer from '../components/dashOverview/MapContainer.vue'
import FooterInfos from '../components/dashOverview/FooterInfos.vue'
import ButtonsToCsvXls from '../components/dashOverview/ButtonsToCsvXls.vue'
import { FULL } from '../../utils/consts'
import WizardStepper from '../components/dashOverview/WizardStepper.vue'

export default {

    name: 'DashOverview',

    components: { 
        WizardStepper, 
        ModalToPayment, 
        WelcomeDashContainer, 
        VisitContainer, 
        InfosContainer, 
        FilterContainer, 
        ClicksContainer, 
        FooterContainer, 
        ImpressionByLocationTableContainer, 
        ImpressionByDayChartContainer, 
        MapContainer,
        FooterInfos,
        ButtonsToCsvXls,
         
    },

    filters: {

        ...dashOverviewFilters

    },

    computed: {

        ...mapGetters({
            dashData: 'ProviderVuex/dashData',
            provider: 'ProviderVuex/provider',
            account: 'AccountVuex/account',
        }),

        impressionsWeek() {

            return this.dashData?.impressions?.impressionsWeek || 0

        },

        checkAccountIncomplete() {

            if (this.account?.status === 'Incomplete') return true

            return false

        },
    },

    data() {
        return {
            dialogWizard: false,
            alertData: {},
            loading: false,
            yearSelected: 'Total',
            filterAlert: false,
            full: FULL
        }
    },

    methods: {

        ...mapActions({
            getTablesData: `ProviderVuex/${GET_DASHDATA}`,
            getProfile: GET_PROFILE
        }),

        ...mapMutations({
            setData: `ProviderVuex/${SET_DASHDATA}`,

        }),

        afterWizard() {

            this.dialogWizard = false
            this.dialogPayment = true

        },

        afterWizardFail() {

            return

        },

        showAlert(event) {

            this.alertData = event
            this.filterAlert = true
        },

        async checkProvider() {

            this.loading = true

            if (!this.provider?._id) {

                try {

                    await this.getProfile();

                    this.setData([])

                    if (this.account.status === 'Incomplete') return this.dialogPayment = true

                    else this.dialogWizard = true


                } catch (error) {

                    return this.$router.push(ROUTE_HOME_ACCOUNT)

                } finally {

                    this.loading = false

                }

            }

            if(this.provider?._id) {

                this.account.plan.services === FULL ? await this.getTablesData({ id: this.provider._id, initDate: this.provider.created_at, endDate: new Date().toString() }) :
                    console.log('Not full plan')

                if(this.account.status === 'Inactive') this.dialogPayment = true;

                if(!this.provider.logo) this.dialogWizard = true

                this.loading = false

                return

            }

        },

    },

    created() {

        this.checkProvider()

    },

    mounted() {
        this.$loadScript("https://wchat.freshchat.com/js/widget.js")
            .then(() => {

                window.fcWidget.init({
                    token: process.env.VUE_APP_FRESHCHAT_TOKEN,
                    host: "https://wchat.freshchat.com",

                });

            })
            .catch(err => {
                console.log(err)
            });
    },

}
</script>

<style scoped>
.view {

    height: 100%;
    width: 100%;

}

.container-view {

    max-width: 1280px;
    margin: 0 auto 0 auto

}

.container-head {

    height: 200px;
    background-color: grey;

}


.container-filter {

    height: 80px;
    background-color: white;

}

.red-box {

    box-shadow: 2px 2px 2px 2px red;

}

.stripe {

    min-width: 268px;

}

.map {}

.blocks {

    width: 99%;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 10px;
    margin-top: 10px;


}

.clicks-box {

    margin-left: 8%;
    margin-right: 8%;


}

.btn-search {

    height: 54px !important;

}

</style>
